/**
 * Maps UI module names (with hyphens) to backend module names (with underscores)
 * This ensures consistency between frontend and backend module name formats
 */
export function mapModuleNameToBackend(uiModuleName: string): string {
  const moduleNameMap: Record<string, string> = {
    'client-invoice': 'client_invoice',
    'client-order': 'client_order',
    'client-so': 'client_order',
    'client-payment': 'client_payment',
    'client-return': 'client_return',
    'client-refund': 'client_refund',
    'client-credit-note': 'client_credit_note',
    'credit-note': 'client_credit_note',
    'vendor-invoice': 'vendor_invoice',
    'vendor-pi': 'vendor_invoice',
    'vendor-po': 'vendor_po',
    'vendor-payment': 'vendor_payment',
    'vendor-return': 'vendor_return',
    'vendor-debit-note': 'vendor_debit_note',
    'vendor-grn': 'vendor_grn',
    'item': 'items',
    'items': 'items',
    'client': 'clients',
    'clients': 'clients',
    'vendor': 'vendors',
    'vendors': 'vendors',
    'accounts': 'accounts',
    'journal-voucher': 'journal_voucher',
    'asset': 'asset',
    'asset-transfer': 'asset_transfer',
    'asset-maintenance-request': 'asset_maintenance_request',
    'bmw-collection-request': 'bmw_collection_request',
    'bmw-disposal': 'bmw_disposal',
    'bmw-waste-category': 'bmw_waste_category',
    'bmw-container': 'bmw_container',
    'bmw-department': 'bmw_department',
    'bmw-ward-room': 'bmw_ward_room',
  };

  // Return mapped name if exists, otherwise return the original (assuming it's already in correct format)
  return moduleNameMap[uiModuleName] || uiModuleName;
}

/**
 * Resolves a backend module name to the correct service base URL.
 * Maps module prefixes to environment URL keys. Modules not matched fall back to accountingUrl.
 *
 * Usage:
 *   import { getServiceUrl } from '@ui-nuvertos/shared/utils/module-name-mapper';
 *   const url = getServiceUrl('bmw_disposal'); // → environment.bmwUrl
 */
export function getServiceUrl(moduleName: string, env: Record<string, any>): string {
  // Module prefix → environment URL key. Accept both `_` and `-` separators
  // since frontend module identifiers often use hyphens (e.g. `cssd-decontamination`).
  const serviceMap: Record<string, string> = {
    'bmw_':  'bmwUrl',
    'bmw-':  'bmwUrl',
    'cssd_': 'cssdUrl',
    'cssd-': 'cssdUrl',
  };

  for (const [prefix, urlKey] of Object.entries(serviceMap)) {
    if (moduleName.startsWith(prefix) && env[urlKey]) {
      return env[urlKey];
    }
  }

  return env['accountingUrl'] || '';
}

